import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, HostBinding, Inject, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ProductCardComponent } from 'src/business/product/components/product-card/product-card.component';
import { CatalogContentAndSearchResolver, SearchResult } from 'src/core-lib/navigation/services/content.resolver';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { DialogModule } from 'src/layout/dialog/dialog.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { PaginationModule } from 'src/layout/pagination/pagination.module';
import { CatalogBanner } from '../../models/catalog.model';
import { CatalogFormComponent } from '../catalog-form/catalog-form.component';





@Component({
    selector: 'app-catalog-search-layout',
    templateUrl: './catalog-search-layout.component.html',
    styleUrls: ['./catalog-search-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        DialogModule,
        TranslateModule,
        PaginationModule,
        TagManagerModule,
        CommonModule,
        MediaModule,
        CatalogFormComponent,
        GridModule,
        ProductCardComponent
    ]
})
export class CatalogSearchLayoutComponent {

    _maxPage: number;
    size: number;
    @HostBinding('class.pointer') pointerIsSharp: boolean;
    @ViewChild("overlay") overlayTemplate: TemplateRef<any>;
    @Input() tags: string[][];
    @Input() banners: CatalogBanner[];
    @Input() listName: string;
    @Input() listId: string;
    @Input() result: SearchResult;

    constructor(
        private searchService: CatalogContentAndSearchResolver,

    ) {
        this.size = this.searchService.size;

    }


    requestByUrl() {
        // this.searchService.requestByUrl(); // TODO
    }

    idTrack(index: number, item: { id: string }) {
        return item.id;
    }

    openOverlay() {
        window['catalog-modal'].showModal();
    }


}
